import { memo } from 'react';
import { motion } from 'framer-motion';

import { useGetParams } from '../../hooks/useGetParams';

import styles from './Advt.module.css';

import { BgVideo } from '../BgVideo/BgVideo';
import { StartBgVideo } from '../StartBgVideo/StartBgVideo';

export const Advt = memo(() => {
  const { title, qrCode1, qrCode2, titleFontSize, sizeQR } = useGetParams();

  return (
    <div className={styles.advtBlock}>
      {title && (
        <div
          className={styles.titleBlock}
          style={{ fontSize: `${titleFontSize}rem` }}
        >
          <motion.div
            className={styles.titleBgBlock}
            initial={{ y: '35vh' }}
            animate={{ y: 0 }}
            transition={{ delay: 2, duration: 0.5 }}
          >
            <motion.div
              className={styles.titleBg}
              initial={{ scaleY: 0, originY: 'top', y: '-50%' }}
              animate={{ scaleY: 1, originY: 'top', y: '0' }}
              transition={{
                scaleY: { duration: 0.5 },
                y: {
                  delay: 0.25,
                  duration: 0.5,
                },
              }}
            />
          </motion.div>
          <motion.div
            style={{
              width: '100%',
              height: '100%',
              position: 'relative',
              zIndex: '11',
            }}
            initial={{ y: '35vh' }}
            animate={{ y: 0 }}
            transition={{ delay: 2, duration: 0.5 }}
          >
            <motion.div
              className={styles.title}
              initial={{ y: '100%', maskPosition: '0% 100%' }}
              animate={{ y: 0, maskPosition: '0% 0%' }}
              transition={{ delay: 0.4, duration: 0.5 }}
            >
              {title}
            </motion.div>
          </motion.div>
        </div>
      )}

      <div className={styles.qrBlock}>
        {qrCode1 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.1, 1] }}
            transition={{
              scale: {
                times: [0, 0.8, 1],
                duration: 1,
                ease: 'easeOut',
                delay: 2.5,
              },
            }}
            className={styles.qrCode}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode1} alt="qrCode1" />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.1, 1] }}
            transition={{
              scale: {
                times: [0, 0.8, 1],
                duration: 1,
                ease: 'easeOut',
                delay: 3,
              },
            }}
            className={styles.qrCode}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode2} alt="qrCode1" />
          </motion.div>
        )}
      </div>

      <StartBgVideo />
      <BgVideo />
    </div>
  );
});
